import React, { useState, useEffect } from 'react';
import { VscChevronRight, VscChevronLeft } from 'react-icons/vsc';
import './style/Banner.css';

import Banner1 from '../image/Image _ Page/Home_page/main-banner-2.jpg';
import Banner2 from '../image/Image _ Page/Home_page/main-banner-3.jpg';
import Banner3 from '../image/Image _ Page/Home_page/main-banner-4.jpg';
import Banner4 from '../image/Image _ Page/Home_page/main-banner-1.jpg';
import Banner5 from '../image/Image _ Page/Home_page/main-banner-3.jpg';
import Banner6 from '../image/Image _ Page/Home_page/main-banner-4.jpg';
import Banner7 from '../image/Image _ Page/Home_page/main-banner-1.jpg';

const Banner = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const featureImageList = [
        { image: Banner1 },
        { image: Banner2 },
        { image: Banner3 },
        { image: Banner4 },
        { image: Banner5 },
        { image: Banner6 },
        { image: Banner7 },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide + 1) % featureImageList.length);
        }, 3000); // Change every 3 seconds

        return () => clearInterval(interval); // Clear interval on component unmount
    }, [featureImageList.length]);

    // Handlers for next and previous slides
    const nextSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide + 1) % featureImageList.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prevSlide) => 
            (prevSlide - 1 + featureImageList.length) % featureImageList.length
        );
    };

    return (
        <div className="banner-container">
            {featureImageList.map((slide, index) => (
                <img
                    src={slide.image}
                    key={index}
                    className={`banner-image ${index === currentSlide ? "opacity-100 active" : "opacity-0"}`}
                    alt={`Slide ${index + 1}`}
                />
            ))}
            <div className="banner-overlay" />
            <div className="banner-content">
                
                {currentSlide === 0 && (
                    <>
                    
                        <h2>DIGITAL INNOVATION <br/> STARTS HERE</h2>

                        <p className="banner-subtext">We make it simple, faster and easy deployable</p>
                    </>
                )}
                {currentSlide === 1 && (
                    <>
                        <h2>OUR MISSION</h2>
                        <p className="banner-subtext">Seamless IT Integration for Business Growth & Security</p>
                    </>
                )}
                {currentSlide === 2 && (
                    <>
                        
                        <h2>ENTERPRISE COMPUTING, STORAGE & VIRTUALIZATION</h2>
                        <p className="banner-subtext"> Optimized, Scalable, and Resilient IT Ecosystems</p>
                    </>
                )}
                {currentSlide === 3 && (
                    <>
                    
                        <h2>NETWORKING & CYBERSECURITY </h2>

                        <p className="banner-subtext">Secure, Scalable, and Future-Ready IT Infrastructure</p>
                    </>
                )}
                {currentSlide === 4 && (
                    <>
                        <h2>ARTIFICIAL INTELLIGENCE</h2>
                        <p className="banner-subtext">Revolutionizing IT with Intelligent Automation</p>
                    </>
                )}
                {currentSlide === 5 && (
                    <>
                        <h2>CLOUD, DEVOPS & DIGITAL TRANSFORMATION</h2>
                        <p className="banner-subtext">Accelerating Business Agility Through Cloud & Automation</p>
                    </>
                )}
                {currentSlide === 6 && (
                    <>
                        <h2>MANAGED IT SERVICES</h2>
                        <p className="banner-subtext">Proactive IT Support for Maximum Uptime & Efficiency</p>
                    </>
                )}
                
            </div>

            {/* <div className="banner-content">
                {currentSlide === 0 && (
                    <>
                    
                        <h2>DIGITAL INNOVATION <br/> STARTS HERE</h2>

                        <p className="banner-subtext">We make it simple, faster and easy deployable</p>
                    </>
                )}
                {currentSlide === 1 && (
                    <>
                        <h2>OUR MISSION</h2>
                        <p className="banner-subtext">Empowering Businesses Through Seamless System Integration</p>
                    </>
                )}
                {currentSlide === 2 && (
                    <>
                        <h2>UNLOCK THE TRUE <br /> POWER OF TECHNOLOGY</h2>
                        <p className="banner-subtext">Where Innovation Meets IT Excellence</p>
                        
                    </>
                )}
                {currentSlide === 3 && (
                    <>
                        <h2>ARTIFICIAL INTELLIGENCE</h2>
                        <p className="banner-subtext">The Future of IT Unleashed</p>
                    </>
                )}
            </div> */}
            {/* Navigation Arrows */}
            <div className="banner-navigation">
                <VscChevronLeft className="banner-arrow left-arrow" onClick={prevSlide} />
                <VscChevronRight className="banner-arrow right-arrow" onClick={nextSlide} />
            </div>
        </div>
    );
};

export default Banner;
